'use client';
import React from 'react';
import { Layout, Typography } from 'antd';
import styles from './Footer.module.scss';
import { ChromeIcon } from '@/public/assets/icons/ChromeIcon';
import { useLocale, useTranslations } from 'next-intl';
import Link from 'next/link';

const { Footer: FooterAntd } = Layout;

export function Footer() {
  const t = useTranslations('footer');
  const locale = useLocale();

  return (
    <FooterAntd className={styles.root}>
      <div className={styles.root_inner}>
        <div className={styles.root_brand}>
          <div className={styles.root_brand_logo}>
            <figure className={styles.root_brand_logo_icon}>
              <ChromeIcon color="white" size={'0.7dvw'} />
            </figure>
            <Typography className={styles.root_brand_logo_title}>MiniApp Every Day</Typography>
          </div>
          <p className={styles.root_brand_desc}>
            {t('desc')}
          </p>
        </div>
        <div className={styles.root_col}>
          <h3 className={styles.root_col_heading}>{t('product')}</h3>
          <Link className={styles.root_col_link} href={`/${locale}/extensions`}>{t('extensions')}</Link>
          <Link className={styles.root_col_link} href={`/${locale}/textremover`}>Text Remover</Link>
          <Link className={styles.root_col_link} href={`/${locale}/drawingonline`}>Drawing Online</Link>
        </div>
        <div className={styles.root_col}>
          <h3 className={styles.root_col_heading}>{t('company')}</h3>
          <Link className={styles.root_col_link}
            href="mailto:messages@i-sol.eu">
            messages@i-sol.eu
          </Link>
          <Link className={styles.root_col_link}
            href="https://www.linkedin.com/company/i-sol"
            target="_blank"
            rel="noopener noreferrer">
            linkedin.com
          </Link>
        </div>
        <div className={styles.root_col}>
          <h3 className={styles.root_col_heading}>{t('legal')}</h3>
          <Link className={styles.root_col_link}
            href="/docs/Extension_Privacy_Policy.pdf"
            rel="noopener noreferrer">{t('privacy')}</Link>
        </div>
      </div>
      <div className={styles.root_bottom}>
        <hr className={styles.root_bottom_divider} />
        <p className={styles.root_bottom_copy}>
          © 2026 MINIAPP EVERY DAY. ALL RIGHTS RESERVED.
        </p>
      </div>
    </FooterAntd>
  );
}
